interface StoryCardProps {
  story: any;
  onClick: () => void;
  onTagClick?: (tag: string) => void;
}

export default function StoryCard({ story, onClick, onTagClick }: StoryCardProps) {
  const coverGradients = [
    'from-purple-600 to-blue-600',
    'from-rose-600 to-pink-600',
    'from-emerald-600 to-teal-600',
    'from-amber-600 to-orange-600',
    'from-cyan-600 to-blue-600',
    'from-violet-600 to-purple-600',
  ];
  const gradient = coverGradients[story.id % coverGradients.length];

  const tags: string[] = story.tags || [];
  const visibleTags = tags.slice(0, 3);
  const remainingCount = tags.length - 3;

  return (
    <div
      onClick={onClick}
      className="group text-left bg-gray-900 border border-gray-800 rounded-xl overflow-hidden hover:border-ink-500/50 transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-ink-500/10 w-full cursor-pointer"
    >
      <div className={`aspect-[6/9] bg-gradient-to-br ${gradient} relative overflow-hidden`}>
        {story.coverUrl ? (
          <img src={story.coverUrl} alt={story.title} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center p-4">
            <span className="text-white/90 text-lg font-serif font-bold text-center leading-tight">
              {story.title}
            </span>
          </div>
        )}
        {story._count?.follows < 500 && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-amber-500 text-gray-900 text-xs font-bold rounded-full">
            New Voice
          </div>
        )}
        {story.isMature && (
          <div className="absolute bottom-0 left-0 right-0 bg-red-900/90 backdrop-blur-sm px-2 py-1.5 flex items-center justify-center gap-1.5">
            <span className="text-sm">🔞</span>
            <span className="text-red-200 text-xs font-bold tracking-wide uppercase">18+ Content</span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-semibold text-sm text-gray-100 group-hover:text-ink-400 transition-colors line-clamp-1">
          {story.title}
        </h3>
        <p className="text-xs text-gray-500 mt-0.5">by {story.penName?.penName || story.author?.username}</p>
        <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
          <span className="px-1.5 py-0.5 bg-gray-800 rounded text-gray-400">{story.genre}</span>
          {story._count && (
            <>
              <span>{story._count.chapters} ch</span>
              <span>·</span>
              <span>{story._count.follows} follows</span>
            </>
          )}
        </div>
        {visibleTags.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {visibleTags.map(tag => (
              <span
                key={tag}
                onClick={e => { e.stopPropagation(); onTagClick?.(tag); }}
                className="px-1.5 py-0.5 bg-gray-800/60 text-gray-500 text-[10px] rounded-full hover:bg-gray-700 hover:text-gray-300 transition-colors cursor-pointer"
              >
                {tag}
              </span>
            ))}
            {remainingCount > 0 && (
              <span className="px-1.5 py-0.5 text-gray-600 text-[10px]">+{remainingCount} more</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
